import { Controller } from "@hotwired/stimulus"
import { plugin } from "../native"

// "Take a photo" buttons: use the native camera inside the app, otherwise let the <label>/<input capture> do its normal thing.
// Usage: on a label/button, data-action="click->native-camera#capture" and data-native-camera-input-value="#input-id".
export default class extends Controller {
  static values = { input: String }

  async capture(event) {
    const camera = plugin("Camera")
    if (!camera) return // browser: default behaviour (file input with capture)

    event.preventDefault()
    try {
      const photo = await camera.getPhoto({ quality: 85, resultType: "base64", source: "CAMERA", correctOrientation: true, width: 2400 })
      const input = document.querySelector(this.inputValue) || this.element.querySelector("input[type=file]")
      const bytes = Uint8Array.from(atob(photo.base64String), (c) => c.charCodeAt(0))
      const file = new File([bytes], `photo-${Date.now()}.${photo.format || "jpeg"}`, { type: `image/${photo.format || "jpeg"}` })
      const transfer = new DataTransfer()
      if (input.multiple) Array.from(input.files).forEach((existing) => transfer.items.add(existing))
      transfer.items.add(file)
      input.files = transfer.files
      input.dispatchEvent(new Event("change", { bubbles: true }))
    } catch (error) {
      // The user cancelled, or denied camera access: fall back to the picker.
      if (!/cancel/i.test(String(error && error.message))) document.querySelector(this.inputValue)?.click()
    }
  }
}
